import React from 'react';

/**
 * LivingAvatar — the dashboard hero. Renders the MASTER COMPOSITE (one AI image
 * blending all four pillars) edge-to-edge as a 4:5 hero, so it fills its card
 * with NO side bands. object-cover keeps the upper body / face as the focus.
 *
 * If there's no generated avatar to show (e.g. the coaching engine is offline
 * and the image can't be fetched/generated) we render NOTHING — never a generic
 * stand-in. The avatar reappears the moment the user's own image loads.
 */
export const LivingAvatar = ({ src }) => {
  const [errored, setErrored] = React.useState(false);
  React.useEffect(() => { setErrored(false); }, [src]);

  if (!src || errored) {
    return (
      <div className="relative w-full overflow-hidden bg-white/[0.02]" style={{ aspectRatio: '4 / 5' }} data-testid="living-avatar" />
    );
  }

  return (
    <div className="relative w-full overflow-hidden" style={{ aspectRatio: '4 / 5' }} data-testid="living-avatar">
      <img
        src={src}
        alt="Your wellness avatar"
        draggable={false}
        onError={() => setErrored(true)}
        className="lv-breathe absolute inset-0 w-full h-full select-none"
        style={{ objectFit: 'cover', objectPosition: 'center 18%' }}
      />
      <div className="absolute inset-x-0 bottom-0 h-2/5 pointer-events-none" style={{ background: 'linear-gradient(0deg, rgba(0,0,0,.6), transparent)' }} />
    </div>
  );
};

export default LivingAvatar;
